import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';

/**
 * ProtectedRoute prüft auf gültigen Auth-Token.
 * Ohne Token → Redirect zur Login-Seite.
 * Mit adminOnly → zusätzlich Prüfung ob User Admin ist.
 */
export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, loading, isAuthenticated } = useAuth();
  const location = useLocation();
  const { t } = useLanguage();

  // Während des Ladens nicht weiterleiten
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-pulse text-muted-foreground">{t('home.wirdGeladen')}</div>
      </div>
    );
  }

  // Kein Token = nicht eingeloggt → zur Anmeldung
  if (!isAuthenticated || !user) {
    return <Navigate to="/?login=true" state={{ from: location }} replace />;
  }

  // Admin-Route: Nur Admins, Manager und Ticket-Controller dürfen zugreifen (Ticket-Controller nur Ticket-Kontrolle)
  if (adminOnly && !user.is_admin && !user.is_manager && !user.is_ticket_controller) {
    return <Navigate to="/portal" replace />;
  }

  return children;
};
